import PropTypes from "prop-types";
import QuestionAnswer from "./QuestionAnswer";

const ScreenerConfirmation = ({ responseSet: responseSetJSON }) => {
  const responseSet = JSON.parse(responseSetJSON);
  const grouped = responseSet.responses.reduce((acc, response) => {
    const key = response.question_id;
    (acc[key] = acc[key] || []).push(response);
    return acc;
  }, {});
  const groupedAnswers = Object.values(grouped);
  const responses = groupedAnswers
    .map((qa) => ({
      question: qa[0].question.text,
      order: qa[0].question.order,
      type: qa[0].question.type,
      answers: qa.map((a) => a.answer.text),
      responseId: qa[0].id,
    }))
    .sort((a, b) => a.order - b.order);

  const token = responseSet.token;
  const surveyId = responseSet.survey_id;

  return (
    <div className="row survey-container">
      <div className="summary confirmation">
        <div className="survey-content">
          <div className="survey-form">
            <div className="confirmation-header">
              <a href={`/assessments/${surveyId}`}>Back to Screener</a>
              <a className="survey-confirm btn btn-primary" href={`/assessments/response_sets/${token}`}>
                Continue to Screener Worksheet
              </a>
            </div>
            <h2>Confirm your responses</h2>
            <div className="answers">
              {responses.map((questionAnswer, index) => (
                <QuestionAnswer key={index} questionAnswer={questionAnswer} />
              ))}
            </div>
            <div className="confirmation-footer">
              <a className="btn btn-primary" href={`/assessments/response_sets/${token}`}>
                Continue to Screener Worksheet
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ScreenerConfirmation.propTypes = {
  responseSet: PropTypes.string,
};

export default ScreenerConfirmation;
